import { useNavigate } from "react-router-dom";
import {
  signInWithPopup,
  getAuth,
  GoogleAuthProvider,
} from "firebase/auth";
import { doc, setDoc, getDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebaseConfig";
import { message, Button } from "antd";
import { GoogleOutlined } from "@ant-design/icons";

function OAuth() {
  const navigate = useNavigate();

  const clickGoogleHandler = async () => {
    try {
      const auth = getAuth();
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      const docRef = doc(db, "users", user.uid);
      const userChatsRef = doc(db, "userChats", user.uid);
      const docSnap = await getDoc(docRef);

      if (!docSnap.exists()) {
        await setDoc(docRef, {
          fullName: user.displayName,
          email: user.email,
          uid: user.uid,
          userRole: "USER",
          dailyLikes: 0,
          avatarUrl: user.photoURL,
          profileCompleted: false,
          timestamp: serverTimestamp(),
        });
        await setDoc(userChatsRef, {});
        message.success("Great! Let's create your profile!");
        navigate("/onboarding");
      } else {
        if (docSnap.data().profileCompleted) {
          message.success("Welcome back!");
          navigate("/");
        } else {
          message.success("Let's complete your profile!");
          navigate("/onboarding");
        }
      }
    } catch (error) {
      console.error("Google auth error:", error);
      switch (error.code) {
        case "auth/account-exists-with-different-credential":
          message.error("Account already exists with different sign-in method");
          break;
        case "auth/popup-closed-by-user":
          message.warning("Sign-in cancelled");
          break;
        default:
          message.error("Couldn't sign in with Google. Please try again.");
      }
    }
  };

  return (
    <Button
      size="large"
      onClick={clickGoogleHandler}
      style={{
        width: '100%',
        height: '50px',
        borderRadius: '12px',
        border: '2px solid #e5e7eb',
        background: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        fontSize: '16px',
        fontWeight: '500',
        color: '#374151',
        transition: 'all 0.3s ease'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = '#d1d5db';
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)';
        e.currentTarget.style.transform = 'translateY(-2px)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = '#e5e7eb';
        e.currentTarget.style.boxShadow = 'none';
        e.currentTarget.style.transform = 'translateY(0)';
      }}
    >
      <GoogleOutlined style={{ fontSize: '20px', color: '#db4437' }} />
      Continue with Google
    </Button>
  );
}

export default OAuth;